import EmailResponseView from './EmailResponseView';
import SmsResponseView from './SmsResponseView';
import TextResponseView from './TextResponseView';
import CareplanResponseView from './CareplanResponseView';
import JobResponseView from './JobResponseView';

export default {
  'EMAIL': EmailResponseView,
  'SMS': SmsResponseView,
  'TEXT': TextResponseView,
  'CAREPLAN': CareplanResponseView,
  'JOB': JobResponseView,
};

